const getExtensionFromPath = (path: string) => {
  const m = path.toLowerCase().match(/\.([a-zA-Z0-9]{2,4})(\?|$)+/)
  return m ? m[1] : undefined
}

export default getExtensionFromPath
